export default function Dashboard() {
  return (
    <div className="page dashboard">
      <h2>Dashboard</h2>

      <div className="card">
        <h3>Start a New Project</h3>
        <p>Submit a new project intake request.</p>
        <a href="/intake/start" className="btn primary">
          Start Intake
        </a>
      </div>

      <div className="card">
        <h3>Project Status</h3>
        <p>No active projects yet.</p>
      </div>
    </div>
  );
}
